import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { buildTimeStringFromTimestamp } from '../../../../../components/common/time/timeHelper'
import { StatusIndicator } from '../../../../../components/utilities/StatusIndicator'

const CheckDetailTitle = ({ email, status, createdAt }) => {
  const { t } = useTranslation(['common', 'messages'])
  const boxStyle = { display: 'flex', alignItems: 'center', gap: '.5rem' }

  return (
    <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '0 .5rem' }}>
      <Box sx={boxStyle}>
        <Typography variant="subtitle1">{t('common:executedBy')}:</Typography>
        <Typography variant="subtitle3">{email ?? '---'}</Typography>
      </Box>
      <Box sx={boxStyle}>
        <Typography variant="subtitle1">{t('common:status')}:</Typography>
        <Typography variant="subtitle3">{status ? <StatusIndicator type={status} size='16px' variant='subtitle3'/> : '---'}</Typography>
      </Box>
      <Box sx={boxStyle}>
        <Typography variant="subtitle1">{t('common:creationDate')}:</Typography>
        <Typography variant="subtitle3">{buildTimeStringFromTimestamp(createdAt) ?? '---'}</Typography>
      </Box>
    </Box>
  )
}

export default CheckDetailTitle
